<script lang="ts">
  import BaseModule from '$src/js/modules/base/BaseModule';
  import { voteTargetDate } from '$src/js/states/VoteState.svelte';

  const pad = (n: number): string => String(n).padStart(2, '0');

  const getTimeLeft = (): { days: number; hours: number; minutes: number } => {
    const diff = Math.max(0, voteTargetDate.getTime() - Date.now());
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    return { days, hours, minutes };
  };

  let timeLeft = $state(getTimeLeft());

  const units = $derived([
    {
      value: pad(timeLeft.days),
      label: BaseModule.getInstance().i18n.translate('countdown_days'),
      yellow: true,
    },
    {
      value: pad(timeLeft.hours),
      label: BaseModule.getInstance().i18n.translate('countdown_hours'),
      yellow: false,
    },
    {
      value: pad(timeLeft.minutes),
      label: BaseModule.getInstance().i18n.translate('countdown_minutes'),
      yellow: false,
    },
  ]);

  $effect(() => {
    const interval = setInterval(() => {
      timeLeft = getTimeLeft();
    }, 1000);
    return () => clearInterval(interval);
  });
</script>

{#if voteTargetDate.getTime() > Date.now()}
  <div class="mb-16 flex items-start gap-6 sm:mb-24 sm:gap-12">
    {#each units as unit}
      <div class="flex shrink-0 flex-col items-end gap-3">
        <div class="flex flex-col items-center">
          <span
            class="font-clorat w-20 text-center text-[64px] leading-none {unit.yellow
              ? 'text-yellow'
              : 'text-white'} sm:text-[72px]">{unit.value}</span
          >
          <span
            class="font-figtree text-base leading-[1.4] font-normal whitespace-nowrap text-white lowercase opacity-80"
            >{unit.label}</span
          >
        </div>
        <div class="h-[2px] w-20 bg-white/20"></div>
      </div>
    {/each}
  </div>
{/if}
